export default {
    label_task:{
        en:"Distributors Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Distributor Sale",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Distributor Sale",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Distributor Sale",
        bn:'ব্যবহারকারীর বিবরণ'
    },

    label_sales_at:{
        en:"Sales Time",
        bn:"কর্মচারী আইডি"
    },
    label_invoice_no:{
        en:"Invoice No",
        bn:"কর্মচারী আইডি"
    },

}